import React, { Component } from 'react';
import { connect } from 'react-redux';

import classes from './Cars.css';
import Route from '../../containers/Route/Route';
import Request from '../../containers/Request/Request';
import Placeholder from '../../containers/Placeholder/Placeholder';
import Cell from '../../hoc/Cell/Cell';
import axios from '../../axios-trips';
import logError from '../../store/LogError';
import * as actionTypes from '../../store/actions';
import Aux from '../../hoc/Auxiliary/Auxiliary';

export class Cars extends Component {

  state = {
    allObjects: [
      [[], [], [], [], [], []],
      [[], [], [], [], [], []],
      [[], [], [], [], [], []],
      [[], [], [], [], [], []],
      [[], [], [], [], [], []],
      [[], [], [], [], [], []],
      [[], [], [], [], [], []]
    ],
    horizontalRoute: { 'ЛЬВІВ': 0, 'ВІННИЦЯ': 1, 'КИЇВ': 2, 'ХАРКІВ': 3, 'ДНІПРО': 4, 'ОДЕСА': 5 },
    verticalRoute: { 'ЛЬВІВ': 0, 'ВІННИЦЯ': 1, 'КИЇВ': 2, 'ХАРКІВ': 3, 'ДНІПРО': 4, 'ОДЕСА': 5, 'ІМПОРТ': 6 },
    highlightedRoutes: {},
    filterRoute: null,
    regionOrigins: {
      0: null,
      1: null,
      2: null,
      3: null,
      4: null,
      5: null,
      6: null
    }
  }

  createRegionOrigins() {
    const updatedOrigins = { ...this.state.regionOrigins };
    Object.keys(this.props.locations).forEach(location => {
      if (this.props.locations[location].originatingLocation) {
        updatedOrigins[this.props.locations[location].region - 1] = this.props.locations[location];
      }
    });
    this.setState({ regionOrigins: updatedOrigins });
  }

  componentDidMount() {
    if (this.props.locations) {
      this.createRegionOrigins();
    }
    this.updateObjects();
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevProps.locations && this.props.locations) {
      this.createRegionOrigins();
    }

    if (prevProps.routes !== this.props.routes || prevProps.requests !== this.props.requests || this.props.locations !== prevProps.locations) {
      this.updateObjects();
    }

    if (prevProps.filterDispatcher !== this.props.filterDispatcher) {
      this.updateObjects();
    }
  }

  updateObjects(id = -1) {
    let objects = [
      [[], [], [], [], [], []],
      [[], [], [], [], [], []],
      [[], [], [], [], [], []],
      [[], [], [], [], [], []],
      [[], [], [], [], [], []],
      [[], [], [], [], [], []],
      [[], [], [], [], [], []]
    ];

    if (this.props.locations === null || this.props.locations === undefined || this.props.locations.length === 0) {
      return;
    }

    Object.keys(this.props.routes).forEach((route, index) => {
      let currRoute = this.props.routes[index];
      for (let i = 0; i < this.props.routes[index].tripPoints.length - 1; i++) {
        for (let j = i + 1; j < this.props.routes[index].tripPoints.length; j++) {
          const routeAtInterval = { ...currRoute };
          routeAtInterval.origin = i;
          routeAtInterval.destination = j;
          if (objects[routeAtInterval.tripPoints[i].location.region - 1][routeAtInterval.tripPoints[j].location.region - 1]) {
            let routeIndex = -1;
            for (let z = 0; z < objects[routeAtInterval.tripPoints[i].location.region - 1][routeAtInterval.tripPoints[j].location.region - 1].length; z++) {
              if (objects[routeAtInterval.tripPoints[i].location.region - 1][routeAtInterval.tripPoints[j].location.region - 1][z].id === routeAtInterval.id) {
                routeIndex = z;
                break;
              }
            }

            if (routeIndex > -1 && id !== "T" + routeAtInterval.id && !this.props.filterDispatcher) {
              if (objects[routeAtInterval.tripPoints[i].location.region - 1][routeAtInterval.tripPoints[j].location.region - 1][routeIndex].extraRoutes) {
                objects[routeAtInterval.tripPoints[i].location.region - 1][routeAtInterval.tripPoints[j].location.region - 1][routeIndex].extraRoutes
                  .push(routeAtInterval);
              } else {
                objects[routeAtInterval.tripPoints[i].location.region - 1][routeAtInterval.tripPoints[j].location.region - 1][routeIndex].extraRoutes = [routeAtInterval];
              }
            } else {
              objects[routeAtInterval.tripPoints[i].location.region - 1][routeAtInterval.tripPoints[j].location.region - 1]
                .push(routeAtInterval);
            }
          }
        }
      }
    });

    if (this.props.requests) {
      Object.keys(this.props.requests).forEach((request, index) => {
        let currRequest = this.props.requests[index];
        if (currRequest.tripId === null || currRequest.tripId === undefined) {
          if (
            !objects[this.props.locations[currRequest.origin.locationName].region - 1] ||
            !objects[this.props.locations[currRequest.origin.locationName].region - 1][this.props.locations[currRequest.destination.locationName].region - 1]
          ) {
            console.log("Someone's being naughty ", objects, currRequest);
            return;
          }
          objects[this.props.locations[currRequest.origin.locationName].region - 1][this.props.locations[currRequest.destination.locationName].region - 1]
            .push(currRequest);
        }
      });
    }

    this.setState({ allObjects: objects });
  }

  updateCard = (request) => {
    this.setState({ loading: true });
    axios({
      method: 'post',
      url: '/api/v1/requests/update',
      data: request,
      headers: { 'Authorization': 'Bearer ' + this.props.access_token },
    })
      .then(response => {
        console.log(response);
        this.setState({ loading: false });
        this.onRequestUpdateHandler(request);
      })
      .catch(error => {
        console.log(error);
        this.setState({ loading: false });
        if (error.response) {
          logError(
            this.props.access_token,
            this.props.codeToMessage[error.response.status],
            '/api/v1/requests/update'
          );
          this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
        }
      });
  }

  onRequestUpdateHandler(request) {
    const updatedRequests = [...this.props.requests];
    let index = -1;
    for (let i = 0; i < updatedRequests.length; i++) {
      if (updatedRequests[i].id === request.id) {
        index = i;
        break;
      }
    }

    if (index !== -1) {
      updatedRequests[index] = request;
      this.props.onSetRequests(updatedRequests);
    } else {
      console.log("Something went wrong. Invalid index for request update.");
    }
  }

  stopDrag = (origin, destination) => {
    const updatedObjects = [];
    this.state.allObjects.forEach(obj => {
      updatedObjects.push({ ...obj });
    })

    let i = this.props.locations[this.props.dragInitialData.origin].region - 1;
    let j = this.props.locations[this.props.dragInitialData.destination].region - 1;

    let requestIndex = -1;
    let routeIndex = -1;
    let currRouteIndex = -1;
    let object = null;
    let id = null;
    for (let index = 0; index < updatedObjects[i][j].length; index++) {
      object = { ...updatedObjects[i][j][index] };
      if (object.requestTripDate !== undefined) {
        // Request
        id = "R" + object.id;
      } else {
        // Trip
        id = "T" + object.id;
        if (object.requests && object.requests.length > 0) {
          for (let z = 0; z < object.requests.length; z++) {
            if (("R" + object.requests[z].id) === this.props.dragInitialData.id) {
              requestIndex = z;
              currRouteIndex = index;
            }
          }
        }
      }

      if (id === this.props.dragOverObj) {
        routeIndex = index;
      }
      if (id === this.props.dragInitialData.id) {
        requestIndex = index;
      }
    }

    let request = null;
    if (currRouteIndex > -1) {
      // Request exists under a Trip
      request = { ...updatedObjects[i][j][currRouteIndex] }.requests[requestIndex];
      updatedObjects[i][j][currRouteIndex].requests.splice(requestIndex, 1);
      request.tripId = null;
      request.tripType = null;
    } else {
      request = { ...updatedObjects[i][j][requestIndex] };
    }

    // Assign Request to Trip
    if (routeIndex !== -1) {
      request.tripId = { ...updatedObjects[i][j][routeIndex] }.id;
      request.tripType = { ...updatedObjects[i][j][routeIndex] }.type;
      if (updatedObjects[i][j][routeIndex].requests) {
        updatedObjects[i][j][routeIndex].requests.push(request);
      } else {
        updatedObjects[i][j][routeIndex].requests = [request];
      }

      this.removeRequestNotifications(request.id);
    } else {
      updatedObjects[i][j].push(request);
    }
    this.setState({ allObjects: updatedObjects });
    this.updateCard(request);
    this.props.onStartDrag(null, null, null);
  }

  removeRequestNotifications = (requestId) => {
    const notificationIds = [
      ...Object.keys(this.props.externalNotifications)
        .filter(objKey =>
          this.props.externalNotifications[objKey].tripId === requestId &&
          this.props.externalNotifications[objKey].notificationType === 'Request'
        )
    ];
    axios({
      method: 'post',
      url: '/api/v1/notifications/open-request',
      data: [requestId],
      headers: { 'Authorization': 'Bearer ' + this.props.access_token },
    })
      .then(response => {
        this.removeNotificationsFrontend(notificationIds);
      })
      .catch(error => {
        console.log(error);
      });
  }

  removeNotificationsFrontend(notificationIds) {
    let updatedNotifications = {};
    Object.keys(this.props.externalNotifications).forEach((key, i) => {
      if (!notificationIds.includes(key)) {
        updatedNotifications[key] = { ...this.props.externalNotifications[key] };
      }
    });
    this.props.onSetExternalNotifications(updatedNotifications);
  }

  highlightRoutes = (id, highlight) => {
    const updatedRoutes = { ...this.state.highlightedRoutes };
    updatedRoutes[id] = highlight;
    this.setState({ highlightedRoutes: updatedRoutes });
  }

  filterRoutes = (id) => {
    this.setState({ filterRoute: id });
    this.updateObjects(id);
  }

  render() {

    let transformRoute = (route, from, to, index) => {
      return <Route
        key={"T" + route.id + route.origin + route.destination}
        id={"T" + route.id}
        type={route.type}
        origin={route.origin}
        destination={route.destination}
        tripDate={route.tripDate}
        capacity={route.capacity}
        priority={route.priority}
        price={route.price}
        priceComment={route.priceComment}
        priceConfirmed={route.priceConfirmed}
        carrierId={route.carrier}
        carrierOkpo={route.carrierOkpo}
        carrierPartner={route.carrierPartner}
        carrierName={route.carrierName}
        carrierLs={route.carrierLs}
        carrierConfirmed={route.carrierConfirmed}
        driver={route.driver}
        car={route.car}
        highlighted={this.state.highlightedRoutes["T" + route.id]}
        highlightRoutes={this.highlightRoutes}
        filterRoutes={this.filterRoutes}
        filterRoute={this.state.filterRoute}
        managers={route.managers}
        dispatcher={route.dispatcher}
        note={route.note}
        tripPoints={route.tripPoints}
        setTripHandler={this.props.setTripHandler}
        requests={route.requests ? route.requests : []}
        startDrag={this.initialiseDrag}
        stopDrag={this.stopDrag}
        setRequestHandler={this.props.setRequestHandler}
        from={from}
        to={to}
        extraRoutes={route.extraRoutes} />
    };

    let transformRequest = (request) => {
      return <Request
        key={"R" + request.id}
        id={"R" + request.id}
        origin={request.origin.locationName}
        destination={request.destination.locationName}
        manager={request.manager}
        weight={request.weight}
        requestTripDate={request.requestTripDate}
        dateFlexibility={request.dateFlexibility}
        priority={request.priority}
        requestType={request.requestType}
        partialLoad={request.partialLoad}
        tripId={request.tripId}
        initiator={request.initiator}
        unloading={request.unloading}
        highlighted={request.highlighted}
        unloadAfter={request.unloadAfter}
        moneyRequests={request.moneyRequests}
        accepted={request.accepted}
        sorting={request.sorting}
        setRequestHandler={this.props.setRequestHandler}
        startDrag={this.initialiseDrag}
        stopDrag={this.stopDrag} />
    };

    let createObjects = (i, j, from, to) => {
      let objects = [];
      let object = null;
      for (let index = 0; index < this.state.allObjects[i][j].length; index++) {
        object = this.state.allObjects[i][j][index];
        if (object.requestTripDate !== undefined) {
          // Request
          if (object.tripId == undefined) {
            if (this.props.filterManager && object.manager === this.props.managerName) {
              object.highlighted = true;
            } else {
              object.highlighted = false;
            }

            objects.splice(0, 0, transformRequest(object));
          }
        } else if (!object.archived) {
          // Trip
          if (this.props.filterDispatcher && (object.origin !== 0 || object.carrierConfirmed === true || object.destination !== object.tripPoints.length - 1)) {
            continue;
          }
          if (this.state.filterRoute && ("T" + object.id) !== this.state.filterRoute) {
            continue;
          }
          if (this.props.filterManager) {
            let foundManager = false;
            if (object.requests) {
              for (let z = 0; z < object.requests.length; z++) {
                if (object.requests[z].manager === this.props.managerName) {
                  object.requests[z].highlighted = true;
                  foundManager = true;
                }
              }
            }

            if (!foundManager) {
              continue;
            }
          }
          objects.push(transformRoute(object, from, to, index));
        }
      }

      for (let i = 0; i < objects.length; i++) {
        objects.index = i;
      }

      return objects;
    }

    let horizontalHeadings = [];
    let i = 0;
    for (let key in this.state.horizontalRoute) {
      let gridArea = 'header-1-' + (i + 2);
      horizontalHeadings.push(
        <Cell key={key} cellClass='Heading' gridArea={gridArea} desktopOnly>
          <p>{key}</p>
        </Cell>
      );
      i += 1;
    }

    let verticalBody = [];
    i = 0;
    for (let key in this.state.verticalRoute) {
      let gridArea = 'header-' + (i + 2) + "-1";

      let cells = [];
      var j = 0;
      for (let innerKey in this.state.horizontalRoute) {
        let cellGridArea = 'cell-' + (i + 2) + "-" + (j + 1)
        cells.push(
          <Cell
            key={innerKey + " " + i + " " + j}
            cellClass='Cell'
            gridArea={cellGridArea}
            from={key}
            to={innerKey}
            origin={
              this.state.regionOrigins[this.state.horizontalRoute[key]] ?
                this.state.regionOrigins[this.state.horizontalRoute[key]].locationName :
                key
            }
            destination={innerKey}>
            <Placeholder origin={key} destination={innerKey} />
            {createObjects(i, j, key, innerKey)}
          </Cell>
        );

        j += 1;
      }

      verticalBody.push(
        <Aux
          key={gridArea}>
          <Cell
            key={gridArea}
            cellClass='Heading' gridArea={gridArea}>
            <p>{key}</p>
          </Cell>
          {cells}
        </Aux>
      );

      i += 1;
    }

    return (
      <Aux>
        <div className={classes.Cars}>
          <Cell cellClass='Heading' gridArea='header-1-1' desktopOnly>
            <p>Звідки \ Куди</p>
          </Cell>

          {horizontalHeadings}
          {verticalBody}
        </div>
      </Aux>
    );
  }
}

const mapStateToProps = state => {
  return {
    managerName: state.managerName,
    access_token: state.access_token,
    routes: state.routes,
    name: state.name,
    requests: state.requests,
    dragInitialData: state.dragInitialData,
    dragOverObj: state.dragOverObj,
    locations: state.locations,
    role: state.role,
    filterDispatcher: state.filterDispatcher,
    filterManager: state.filterManager,
    codeToMessage: state.codeToMessage,
    externalNotifications: state.externalNotifications
  };
}

const mapDispatchToProps = dispatch => {
  return {
    onSetRoutes: (routes) => dispatch({
      type: actionTypes.ROUTES,
      routes: routes
    }),
    onSetRequests: (requests) => dispatch({
      type: actionTypes.REQUESTS,
      requests: requests
    }),
    onSetExternalNotifications: (externalNotifications) => dispatch({
      type: actionTypes.SET_EXTERNAL_NOTIFICATIONS,
      externalNotifications: externalNotifications
    }),
    onStartDrag: (id, origin, destination) => dispatch({
      type: actionTypes.START_DRAG,
      id: id,
      origin: origin,
      destination: destination
    }),
    addNotification: (notification, notificationType) => dispatch({
      type: actionTypes.ADD_NOTIFICATION,
      notification: notification,
      notificationType: notificationType
    }),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Cars);



// WEBPACK FOOTER //
// ./src/components/Cars/Cars.js